export default "__VITE_ASSET__D_XHSh2U__"